<template>
  <Modal
    :is-open="show"
    title="Buy Benchmark credits"
    size="lg"
    bg-variant="darker"
    :close-on-click-outside="true"
    @close="emit('close')"
  >
    <div class="flex flex-col gap-4">
      <p class="text-sm text-white/70">
        Prepaid balance for running benchmarks. Separate from marketplace credits.
      </p>
      <BuyBenchmarkCreditsPanel
        v-if="show"
        show-balance
        element-id="buy-credits-modal-card-element"
        @payment-success="handlePaymentSuccess"
      />
    </div>
  </Modal>
</template>

<script setup>
import { useRouter } from 'vue-router';
import Modal from '@/components/modals/Modal.vue';
import BuyBenchmarkCreditsPanel from '@/components/modals/BuyBenchmarkCreditsPanel.vue';
import { useToast } from '@/composables/use-toast';

const props = defineProps({
  show: {
    type: Boolean,
    default: false,
  },
  redirectOnSuccess: {
    type: Boolean,
    default: true,
  },
});

const emit = defineEmits(['close', 'success']);

const router = useRouter();
const { addToast } = useToast();

const handlePaymentSuccess = (payload) => {
  addToast('Benchmark credits added. You can create your eval now.', 'success');
  emit('success', payload);
  emit('close');
  if (props.redirectOnSuccess) {
    router.push({ path: '/creator-profile', query: { page: 'eval-builder' } });
  }
};
</script>
